/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Highlight_Team_AuditInputs */



/**
* | output |
* | --- |
* | "Audit logs (90-day retention)" |
*
* @param {Plan_Gate_Highlight_Team_AuditInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_highlight_team_audit = /** @type {((inputs?: Plan_Gate_Highlight_Team_AuditInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Highlight_Team_AuditInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Audit-Protokolle (90 Tage Aufbewahrung)")
	return /** @type {LocalizedString} */ ("Audit logs (90-day retention)")
});